export default __webpack_public_path__ + "static/media/orange_large.951667b0.png";